import { UserInfo } from "./user";

export interface WithData<T> {
    data: T;
}
export interface StepProps {
    increaseStep: VoidCallback | PromiseVoidCallback;
    decreaseStep: VoidCallback;
    step?: number;
    setStep?: VoidCallback;
}

export interface RegisterProps {
    increaseStep : () => void,
    decreaseStep : () => void,
}

export type RegisterDetailsType = {
    registerDetails: {
        doc: number | null,
        name: string | null,
        email: string | null,
        mobile: number | null,
        street: string | null,
        number: number | null,
        comp?: number | null,
        neighbourhood: string | null,
        state: string | null,
        zipcode: number | null,
        city: string | null
    },
    comingFromMetamask: boolean,
    blockChainAddress: string,
    blockChainVerificationPharse: string,
    blockChainNetwork: string,
    userSignature: string,
    password: string,
    nickname: string,
    isRegister: boolean
}

export type VoidCallback = () => void
export type PromiseVoidCallback = () => Promise<void>;

export enum tokensImages {
    usdc = 'https://s2.coinmarketcap.com/static/img/coins/64x64/3408.png',
    usdt = 'https://s2.coinmarketcap.com/static/img/coins/64x64/825.png',
    btc = 'https://s2.coinmarketcap.com/static/img/coins/64x64/1.png',
    ton = 'https://s2.coinmarketcap.com/static/img/coins/64x64/11419.png'
}

export const formatDate = (date: string): string => {
    let str;
    if (date) {
        const parsedDate = new Date(date);
        const day = String(parsedDate.getDate()).padStart(2, "0");
        const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Meses começam do 0
        const year = parsedDate.getFullYear();
        const hours = String(parsedDate.getHours()).padStart(2, "0");
        const minutes = String(parsedDate.getMinutes()).padStart(2, "0");
        str = `${day}/${month}/${year} ${hours}:${minutes}`;
    } else {
        str = `processando`;
    }  
    return str;
};

export const getDefaultUserInfo = (): UserInfo => ({
    code: 0,
    data: {
        signed_at: "",
        id: "",
        device_id: "",
        status: 0,
        nickname: "",
        signup_flow: "",
        accounts: []
    }
});